import type { RouteRecordRaw, Router } from 'vue-router'

const PropertyTheftRoutes: RouteRecordRaw = {
  path: '/claim/propertyTheft',
  name: 'PropertyTheftModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PropertyTheftMainRoute',
      component: () => import('./views/PropertyTheftView.vue'),
      meta: {
        title: 'propertyTheft.propertyTheftClaims',
      },
    },
    {
      path: 'create',
      name: 'PropertyTheftCreateRoute',
      component: () => import('./views/PropertyTheftUpsertView.vue'),
      meta: {
        title: 'propertyTheft.createPropertyTheft',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:propertyTheftId',
      name: 'PropertyTheftEditRoute',
      component: () => import('./views/PropertyTheftUpsertView.vue'),
      meta: {
        title: 'propertyTheft.editPropertyTheft',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:propertyTheftId',
      name: 'ViewPropertyTheftRoute',
      component: () => import('./views/SinglePropertyTheftView.vue'),
      meta: {
        title: 'propertyTheft.ViewPropertyTheft',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PropertyTheftRoutes)
}
